import filterConfigurations from "./filterConfigurations";

const valueExists = (val) => typeof val !== "undefined" && val !== null;
const hasPrice = (config) =>
  config &&
  config.product &&
  (valueExists(config.product.prices) || valueExists(config.prices));

const priceOf = (config) => {
  return config.prices.finalPrice.priceInclTax.value.amount;
};
const cheapestLast = (a, b) => priceOf(b) - priceOf(a);

const getSelectedProduct = (configurations, selectedOptions) => {
  if (Object.keys(selectedOptions).length === 0) {
    return null;
  }

  const filteredConfigs = filterConfigurations(configurations, selectedOptions);
  const filteredConfigsByPrice = filteredConfigs.filter(hasPrice);
  const hasInStockConfig = filteredConfigs
    .map((config) => config.product.stock && config.product.stock.isInStock)
    .includes(true);

  let selectedConfiguration;

  if (filteredConfigsByPrice.length === 0) {
    selectedConfiguration = Object.assign({}, filteredConfigs.pop());
  } else {
    selectedConfiguration = Object.assign(
      {},
      [...filteredConfigsByPrice].sort(cheapestLast).pop()
    );
  }
  selectedConfiguration.product = Object.assign(
    {},
    selectedConfiguration.product,
    {
      prices:
        selectedConfiguration?.prices || selectedConfiguration?.product?.prices,
      currentConfigIsInStock: hasInStockConfig,
      currentConfigSku: selectedConfiguration?.product?.sku,
    }
  );

  if (!selectedConfiguration) {
    return null;
  }

  return selectedConfiguration.product;
};

export default getSelectedProduct;
